// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__PKPhI","text":"SelectPayment_text__1dct3","title":"SelectPayment_title__1uSJ1","btn":"SelectPayment_btn__gJSh_"};